const TODAY = {
  from: 'now/d',
  to: 'now+1d/d-1s',
  name: 'today',
  interval: 'hour'
};

const YESTERDAY = {
  from: 'now-1d/d',
  to: 'now/d-1s',
  name: 'yesterday',
  interval: 'hour'
};

const lastDays = (days) => ({
  from: `now-${days}d`,
  to: 'now',
  name: 'last_days',
  interval: 'day'
});

const THISMONTH = {
  from: 'now/M',
  to: 'now+1M/M-1s',
  name: 'last_days',
  interval: 'day'
};

const lastMonths = (months) => ({
  from: `now-${months}M/M`,
  to: 'now/M-1s',
  name: 'last_months',
  interval: 'day'
});

const lastYears = (years) => ({
  from: `now-${years}y/y`,
  to: 'now+1y/y-1s',
  name: 'last_years',
  interval: 'month'
});

module.exports = {
  TODAY,
  YESTERDAY,
  THISMONTH,
  lastDays: lastDays,
  lastMonths: lastMonths,
  lastYears: lastYears
};
